export enum PeriodStatus {
  notStarted = 'Not Started',
  inProgress = 'In Progress',
  expired = 'Expired',
  completed = 'Completed',
}
